import { defineStore } from "pinia";
import { ref } from "vue";
import { getUserInfo } from "@/api/login";
import { useRouter } from "vue-router";
import { getToken, removeToken } from "@/utils/cookie.js";
export const useUserStore = defineStore("userStore", () => {
  const userInfo = ref({
    id: 0,
    parentId: 0,
    username: "",
    phone: "",
    icon: "",
    iconFrame: "",
    appearance: "",
    defaultGroupId: 0,
    inviteCode: "",
    state: 0,
    lastActiveTime: "",
    updateNameTime: "",
    createTime: "",
    updateTime: "",
  });
  // console.log("getToken()", getToken());
  const router = useRouter();
  const token = ref(getToken() || "");
  // console.log("token", token);
  const getUser = async () => {
    const res = await getUserInfo();
    // console.log("res", res);
    if (res.code == "402") {
      removeToken();
      token.value = "";
      return;
    }
    //记录用户信息
    userInfo.value = res.data;
    if (userInfo.value.state !== 0) {
      router.push("/login/breakLaw");
    }
  };
  token.value && getUser();
  const logout = () => {
    removeToken();
    token.value = "";
    //清除用户信息
    userInfo.value = {
      id: 0,
      parentId: 0,
      username: "",
      phone: "",
      icon: "",
      iconFrame: "",
      appearance: "",
      defaultGroupId: 0,
      inviteCode: "",
      state: 0,
      lastActiveTime: "",
      updateNameTime: "",
      createTime: "",
      updateTime: "",
    };
    router.push("/");
  };
  return {
    userInfo,
    getUser,
    token,
    logout,
  };
});
